/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CheckApiWorkingCommand } from '../../models/check-api-working-command';
import { StringApiResponse } from '../../models/string-api-response';

export interface CheckApiWorkingAsync$Params {
  command?: CheckApiWorkingCommand;
}

export function checkApiWorkingAsync(http: HttpClient, rootUrl: string, params?: CheckApiWorkingAsync$Params, context?: HttpContext): Observable<StrictHttpResponse<StringApiResponse>> {
  const rb = new RequestBuilder(rootUrl, checkApiWorkingAsync.PATH, 'get');
  if (params) {
    rb.query('command', params.command, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StringApiResponse>;
    })
  );
}

checkApiWorkingAsync.PATH = '/api/health-check';
